import { assignSalesperson } from './endpoints';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RequestStatus } from "@app/constants";
import { IRequestFailed } from "@app/types";
import { IRequestsData, IrequestState } from "./types";
import { IProduct } from "../product/types";


// === FIX 1: Initial State ko sahi shape dein ===
const initialState: IrequestState = {
    getrequest: {

    },
    addrequest: {},
    addstatus: {

    },
    requestDetail: {},
    addvaluation: {},
    assignsalesperson: {},
    assignAgent: {},
    deleterequest: {},
    approveSellCar: {},
};

const slice = createSlice({
    name: "request",
    initialState,
    reducers: {
        getrequest(state, action: PayloadAction<IProduct>) {
            state.getrequest.status = RequestStatus.RUNNING;
        },
        requestSuccess(state, action) {
            state.getrequest.status = RequestStatus.SUCCESS;
            state.getrequest.data = action.payload;
        },
        requestFailed(state, action: PayloadAction<IRequestFailed>) {
            state.getrequest.status = RequestStatus.ERROR;
            state.getrequest.error = action.payload;
            state.getrequest.data = []; // Error aane par data ko clear karein
        },
        addStatus(state, action) {
            state.addstatus.status = RequestStatus.RUNNING;
        },
        addStatusSuccess(state, action) {
            state.addstatus.status = RequestStatus.SUCCESS;
            state.addstatus.data = action.payload;
        },
        addStatusFailed(state, action: PayloadAction<IRequestFailed>) {
            state.addstatus.status = RequestStatus.ERROR;
            state.addstatus.error = action.payload;
        },
        addValuation(state, action) {
            state.addvaluation.status = RequestStatus.RUNNING; // ✅ Change to addvaluation
        },
        addValuationSuccess(state, action) {
            state.addvaluation.status = RequestStatus.SUCCESS; // ✅ Change to addvaluation
            state.addvaluation.data = action.payload;
        },
        addValuationFailed(state, action: PayloadAction<IRequestFailed>) {
            state.addvaluation.status = RequestStatus.ERROR; // ✅ Change to addvaluation
            state.addvaluation.error = action.payload;
        },
        AssignSalesPerson(state, action) {
            state.addvaluation.status = RequestStatus.RUNNING; // ✅ Change to addvaluation
        },
        AssignSalesPersonSuccess(state, action) {
            state.addvaluation.status = RequestStatus.SUCCESS; // ✅ Change to addvaluation
            state.addvaluation.data = action.payload;
        },
        AssignSalesPersonFailed(state, action: PayloadAction<IRequestFailed>) {
            state.addvaluation.status = RequestStatus.ERROR; // ✅ Change to addvaluation
            state.addvaluation.error = action.payload;
        },
        AssignAgent(state, action) {
            state.assignAgent.status = RequestStatus.RUNNING; // ✅ Change to addvaluation
        },
        AssignAgentSuccess(state, action) {
            state.assignAgent.status = RequestStatus.SUCCESS; // ✅ Change to addvaluation
            state.assignAgent.data = action.payload;
        },
        AssignAgentFailed(state, action: PayloadAction<IRequestFailed>) {
            state.assignAgent.status = RequestStatus.ERROR; // ✅ Change to addvaluation
            state.assignAgent.error = action.payload;
        },
        requestDetails(state, action: PayloadAction<IRequestsData>) {
            state.requestDetail.status = RequestStatus.RUNNING;
        },
        requestDetailsSuccess(state, action) {
            state.requestDetail.status = RequestStatus.SUCCESS;
            state.requestDetail.data = action.payload;
        },
        requestDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
            state.requestDetail.status = RequestStatus.ERROR;
            state.requestDetail.error = action.payload;
        },
        deleteRequest(state, action: PayloadAction<{ id: number }>) {
            state.deleterequest.status = RequestStatus.RUNNING;
        },
        deleteRequestSuccess(state, action) {
            state.deleterequest.status = RequestStatus.SUCCESS;
            state.deleterequest.data = action.payload;
        },
        deleteRequestFailed(state, action: PayloadAction<IRequestFailed>) {
            state.deleterequest.status = RequestStatus.ERROR;
            state.deleterequest.error = action.payload;
        },
        approveSellCar(state, action: PayloadAction<{ id: number }>) {
            state.approveSellCar.status = RequestStatus.RUNNING;
        },
        approveSellCarSuccess(state, action) {
            state.approveSellCar.status = RequestStatus.SUCCESS;
            state.approveSellCar.data = action.payload;
        },
        approveSellCarFailed(state, action: PayloadAction<IRequestFailed>) {
            state.approveSellCar.status = RequestStatus.ERROR;
            state.approveSellCar.error = action.payload;
        },
    },
});

export default slice.reducer;
export const {
    getrequest,
    requestSuccess,
    requestFailed,
    requestDetails,
    requestDetailsSuccess,
    requestDetailsFailed,
    addStatus,
    addStatusFailed,
    addStatusSuccess,
    addValuation,
    addValuationFailed,
    addValuationSuccess,
    AssignSalesPerson,
    AssignSalesPersonFailed,
    AssignSalesPersonSuccess,
    AssignAgent,
    AssignAgentFailed,
    AssignAgentSuccess,
    deleteRequest,
    deleteRequestFailed,
    deleteRequestSuccess,
    approveSellCar,
    approveSellCarFailed,
    approveSellCarSuccess,
} = slice.actions;

